export const PROMPT_OVERRIDE_KEY = 'townsquare_threads_prompt_override';
